export const Variables = {
  // Colors
  colorBackground: "#F5F6F8",
  colorBlack: "#4F4F4F",
  colorBlackDark: "#000000",
  colorBlue: "#11104B",
  colorGray: "#828282",
  colorGrayClear: "#717B7F",
  colorGrayIcons: "#a9b4b8",
  colorGrayLines: "#4F4F4F",
  colorGreen: "#97C25F",
  colorGreenSuccess: "#2ED47A",
  colorOrange: "#F7AA40",
  colorPink: "#BB6BD933",
  colorPrimary: "#11104B",
  colorRed: "#fd3636",
  colorWhite: "#FFFFFF",
  // Shadows
  ShadowBlack: "6px 5px 18px rgba(0, 0, 0, 0.6)",
  ShadowBlackHover: "6px 0px 18px rgba(0, 0, 0, 0.2)",
  ShadowYellow: "0px 4px 10px rgba(249, 178, 51, 0.24)",
  // Breakpoints using min-width (mobile-first)
  minMobile: "576px",
  minTablet: "768px",
  minLaptops: "1200px",
  // Breakpoints using max-width (desktop-first)
  maxMobile: "575px",
  maxTablet: "768px",
  maxLaptops: "1199px",
  // Page
  maxWidth: "1920px",
  padding: "0 5%",
};
